"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigRequestConsolidator = void 0;
/**
 * Ensures we only have one active config request at a time
 * any calls made while another is ongoing will be merged together by using the latest user object provided
 */
class ConfigRequestConsolidator {
    constructor(requestConfigFunction, handleConfigReceivedFunction, nextUser) {
        this.requestConfigFunction = requestConfigFunction;
        this.handleConfigReceivedFunction = handleConfigReceivedFunction;
        this.nextUser = nextUser;
        this.resolvers = [];
        this.requestParams = null;
    }
    async queue(user, requestParams) {
        if (user) {
            this.nextUser = user;
        }
        if (requestParams) {
            this.requestParams = requestParams;
        }
        const resolver = new Promise((resolve, reject) => {
            this.resolvers.push({
                resolve, reject
            });
        });
        if (!this.currentPromise) {
            this.processQueue();
        }
        return resolver;
    }
    async processQueue() {
        if (!this.resolvers.length) {
            return;
        }
        const resolvers = this.resolvers.splice(0);
        await this.performRequest(this.nextUser).then((result) => {
            if (this.resolvers.length) {
                // if more resolvers have been registered since this request was made, don't resolve anything and just
                // make another request while keeping all the previous resolvers
                this.resolvers.push(...resolvers);
            }
            else {
                resolvers.forEach(({ resolve }) => resolve(result));
                this.handleConfigReceivedFunction(result, this.nextUser);
            }
        }).catch((err) => {
            resolvers.forEach(({ reject }) => reject(err));
        });
        if (this.resolvers.length) {
            this.processQueue();
        }
    }
    async performRequest(user) {
        this.currentPromise = this.requestConfigFunction(user, this.requestParams ? this.requestParams : undefined);
        this.requestParams = null;
        const bucketedConfig = await this.currentPromise;
        this.currentPromise = null;
        return bucketedConfig;
    }
}
exports.ConfigRequestConsolidator = ConfigRequestConsolidator;
//# sourceMappingURL=ConfigRequestConsolidator.js.map